export default __webpack_public_path__ + "static/media/243.38bc9175.jpg";